import { FC, useState } from 'react'
import { Review } from './types/types'
import CommentModal from './Modals/CommentModal'
import styles from './Status.module.scss'

interface CheckComments {
  review: Review | Partial<Review>
  name: string
}

const RequestCheckComments: FC<CheckComments> = ({ name, review }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleClose = () => setIsOpen(false)
  const handleClick = () => setIsOpen(true)
  return (
    <div>
      <div
        className={styles.commentsContainer}
        aria-label="View Comments"
        data-cooltipz-dir="top"
        data-test-id="comments_container"
      >
        <button className={styles.checkCommentsButton} onClick={handleClick}>
          Check comments
        </button>
      </div>
      <CommentModal onCloseClick={handleClose} isOpen={isOpen} name={name} review={review} />
    </div>
  )
}

export default RequestCheckComments
